/**
 * The step that leads to the first reading sent (recipient polish 2026-11-03,
 * DESIGN §8e item 4, §16): at the end of their next own reading after the
 * Altar opens, once "What landed?" is answered and the kept line said, one
 * quiet line from the Quest: "♡ Next in your Quest: read for someone you
 * love ›". Not gold, not a pop-up, shown once. Its link opens the built
 * reading for someone. Never in the gift room.
 */
export const LEAD_SEEN_KEY = 'ma_lead_read_for_someone'
export const LEAD_WORDS = 'read for someone you love ›'
export const LEAD_TEXT = `♡ Next in your Quest: ${LEAD_WORDS}`

/** Due: the Altar is theirs, the Community (which the first send opens) is not yet, never shown before. */
export function readForSomeoneLeadDue (nav, { shown = false, inGiftRoom = false } = {}) {
  if (!nav || !nav.staged || shown || inGiftRoom) return false
  const bar = Array.isArray(nav.bar) ? nav.bar : []
  return bar.some((i) => i.key === 'altar') && !nav.communityOpen
}

/** The chat line, its one link drawn by the nav line (ChatContainerReader `nav_links`). */
export function readForSomeoneLead () {
  return { text: LEAD_TEXT, type: 'reader', _context: 'quest-lead', nav_links: [{ words: LEAD_WORDS, to: 'read-for-someone' }] }
}
